"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeMessages_de_de = void 0;
function backofficeMessages_de_de() {
    return {
        "backoffice.messages.subtitle": "Nachrichten werden automatisiert vom System verschickt. Als Benutzer können keine Nachrichten versendet werden.",
        "backoffice.messages.nodata": "Keine Nachrichten vorhanden",
        "backoffice.messages.nodatatitle": "Noch keine Nachrichten vorhanden.",
        "backoffice.messages.nodatasubtitle": "Sie werden benachrichtigt, sobald eine neue Nachricht vom System eingegangen ist. Achten Sie hierfür auf das Glockensymbol rechts oben neben Ihrem Profilnamen.",
        "backoffice.messages.nolink": "Kein Link vorhanden",
        "backoffice.messages.nosender": "unbekannt",
        "backoffice.messages.details": "Nachrichtendetails",
        "backoffice.messages.title.main": "Nachrichten",
        "backoffice.messages.title.private": "Private Nachrichten",
        "backoffice.messages.title.project": "Projektnachrichten",
        "backoffice.messages.list.tenant.reseller": "Backoffice",
        "backoffice.messages.list.tenant.company": "Firma",
        "backoffice.messages.list.tenant.project": "Projekt",
        "backoffice.messages.list.tenant.user": "Benutzer",
        "backoffice.messages.list.tenant.unknown": "Unbekannter Absender",
        "backoffice.messages.list.table.date": "Datum",
        "backoffice.messages.list.table.from": "Absender",
        "backoffice.messages.list.table.toproject": "An Projekt",
        "backoffice.messages.list.table.messageid": "Nachrichten ID",
        "backoffice.messages.list.table.message": "Nachricht",
        "backoffice.messages.list.table.links": "Links",
        "backoffice.messages.list.table.actions": "Aktionen",
        "backoffice.messages.list.table.markasread": "Als gelesen markieren",
        "backoffice.messages.list.markasread": "Nachricht(en) als gelesen markieren"
    };
}
exports.backofficeMessages_de_de = backofficeMessages_de_de;
